import { render, staticRenderFns } from "./FacDashboard.vue?vue&type=template&id=5c7cf184&"
import script from "./FacDashboard.vue?vue&type=script&lang=js&"
export * from "./FacDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports